document.querySelectorAll('.tab-btn').forEach(button => {
  button.addEventListener('click', () => {
    const tab = button.dataset.tab;

    // Toggle active tab button
    document.querySelectorAll('.tab-btn').forEach(btn => btn.classList.remove('active'));
    button.classList.add('active');

    // Toggle active content
    document.querySelectorAll('.tab-content').forEach(content => {
      content.classList.remove('active');
    });
    document.getElementById(tab).classList.add('active');
  });
});

/*Table cm/inches*/

/* 
  function updateTableUnit(unit) {
  document.querySelectorAll("table").forEach(table => {
    const cells = table.querySelectorAll("tbody td[data-cm]");

    cells.forEach(cell => {
      const cm = parseFloat(cell.dataset.cm);
      if (!isNaN(cm)) {
        cell.textContent = unit === "cm" ? cm : (cm * 0.393701).toFixed(1);
      } else {
        cell.textContent = "";
      }
    });

    table.dataset.unit = unit;
  });
}

document.addEventListener("DOMContentLoaded", () => {
  // Ensure cm is shown by default
  updateTableUnit("cm");

  document.querySelectorAll(".unit-tab").forEach(button => {
    button.addEventListener("click", () => {
      // Toggle active class
      document.querySelectorAll(".unit-tab").forEach(btn => btn.classList.remove("active"));
      button.classList.add("active");

      // Update table units
      updateTableUnit(button.dataset.unit);
    });
  });
}); */

function updateTableUnit(unit) {
    document.querySelectorAll("table").forEach(table => {
      const cells = table.querySelectorAll("tbody td[data-cm]");
      cells.forEach(cell => {
        const cm = parseFloat(cell.dataset.cm);
        if (!isNaN(cm)) {
          cell.textContent = unit === "cm" ? `${cm}` : `${(cm * 0.393701).toFixed(1)}`;
        }
      });
      table.dataset.unit = unit;
    });

    // Update unit-tab active state
    document.querySelectorAll(".unit-tab").forEach(btn => {
      btn.classList.toggle("active", btn.dataset.unit === unit);
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    // Init default to CM
    updateTableUnit("cm");

    // Unit toggle event
    document.querySelectorAll(".unit-tab").forEach(button => {
      button.addEventListener("click", () => {
        updateTableUnit(button.dataset.unit);
      });
    });

    // Tab switch event
    document.querySelectorAll(".tab-btn").forEach(tabBtn => {
      tabBtn.addEventListener("click", () => {
        // Toggle tab active state
        document.querySelectorAll(".tab-btn").forEach(btn => btn.classList.remove("active"));
        tabBtn.classList.add("active");

        const target = tabBtn.dataset.tab;
        document.querySelectorAll(".tab-content").forEach(content => {
          content.classList.remove("active");
        });
        document.getElementById(target).classList.add("active");

        // Reset unit back to cm
        updateTableUnit("cm");
      });
    });
  });



/*input range slider*/
  function updateSliderProgress(slider) {
    const val = ((slider.value - slider.min) / (slider.max - slider.min)) * 100;
    slider.style.setProperty('--progress', `${val}%`);
  }

  document.querySelectorAll('.fit-slider input[type="range"]').forEach(slider => {
    updateSliderProgress(slider);
    slider.addEventListener('input', () => updateSliderProgress(slider));
  });


